
export const general = {
  // App name
  appName: 'PlanWiseNow',
  
  // Home page
  homeTitle: 'Toma el Control de tu Tiempo y Dinero',
  homeSubtitle: 'La plataforma todo-en-uno para gestionar tus finanzas personales, seguir hábitos, establecer metas y aumentar tu productividad con herramientas inteligentes.',
  getStarted: 'Comenzar',
  
  // Navigation and layout
  home: 'Inicio',
  dashboard: 'Panel',
  today: 'Hoy',
  todaySummary: 'Resumen de actividades y eventos importantes para hoy',
  yesterday: 'Ayer',
  tomorrow: 'Mañana',
  
  // Modules
  modules: 'Módulos',
  explore: 'Explorar',
  
  // Module descriptions
  goals: 'Metas',
  goalsDesc: 'Establece y rastrea tus metas personales y profesionales con planificación detallada y seguimiento de progreso.',
  blog: 'Blog',
  blogDesc: 'Lee artículos y consejos para mejorar tu productividad, gestión financiera y desarrollo personal.',
  
  // Common actions
  save: 'Guardar',
  cancel: 'Cancelar',
  edit: 'Editar',
  delete: 'Eliminar',
  add: 'Agregar',
  create: 'Crear',
  update: 'Actualizar',
  close: 'Cerrar',
  open: 'Abrir',
  confirm: 'Confirmar',
  loading: 'Cargando...',
  refresh: 'Actualizar',
  retry: 'Reintentar',
  
  // Error messages
  error: 'Error',
  errorLoadingData: 'Error al cargar los datos',
  tryAgain: 'Intenta de nuevo',
  loadingTodayData: 'Cargando datos del día...',
  loadingHint: 'Si tarda mucho, intenta refrescar',
  problemLoadingData: 'Problema al cargar los datos',
  unexpectedError: 'Ocurrió un error inesperado al cargar la información',
  reloadPage: 'Recargar página',
  
  // Success messages
  success: 'Éxito',
  
  // Empty states
  noData: 'No hay datos disponibles',
  noResults: 'No se encontraron resultados',
  
  // Time-related
  date: 'Fecha',
  time: 'Hora',
  startTime: 'Hora de inicio',
  endTime: 'Hora de fin',
  
  // General sections
  tasksAndGoals: 'Tareas y Objetivos',
  calendarAndEvents: 'Calendario y Eventos',
  financeOverview: 'Vista Financiera',
  
  // Task-related
  overdueTasks: 'Tareas Atrasadas',
  todayTasks: 'Tareas de Hoy',
  todoToday: 'Para Hacer Hoy',
  noOverdueTasks: 'No hay tareas atrasadas',
  noTodayTasks: 'No hay tareas para hoy',
  completedTasks: '{completed} de {total} completadas',
  addQuickTask: 'Agregar tarea rápida...',
  allTasks: 'Todas las Tareas',
  quickTasks: 'Tareas Rápidas',
  noQuickTasks: 'No hay tareas rápidas',
  projectTasks: 'Tareas de Proyecto',
  markAsComplete: 'Marcar como completa',
  events: 'Eventos',
  completed: 'Completado',
  currentStreak: 'Racha Actual',
  bestStreak: 'Mejor Racha',
  compactView: 'Compacta',
  normalView: 'Normal',
  focusedView: 'Enfocada',
  
  // Calendar-related
  specialDates: 'Fechas Especiales',
  todaySchedule: 'Agenda de Hoy',
  noSpecialDates: 'No hay fechas especiales hoy',
  noScheduledEvents: 'No hay eventos programados',
  
  // Finance-related
  todayPayments: 'Pagos de Hoy',
  todayIncome: 'Ingresos de Hoy',
  overdueDebts: 'Deudas Vencidas',
  todayDebts: 'Deudas de Hoy',
  noTodayPayments: 'No hay pagos para hoy',
  noIncome: 'No hay ingresos para hoy',
  noOverdueDebts: 'No hay deudas vencidas',
  noTodayDebts: 'No hay deudas para hoy',
  
  // Reminders-related
  reminders: 'Recordatorios',
  overdueReminders: 'Recordatorios Vencidos',
  todayReminders: 'Recordatorios de Hoy',
  upcomingReminders: 'Próximos Recordatorios',
  noOverdueReminders: 'No hay recordatorios vencidos',
  noTodayReminders: 'No hay recordatorios para hoy',
  noUpcomingReminders: 'No hay recordatorios próximos',
  reminderCompleted: 'Recordatorio completado',
  errorCompletingReminder: 'Error al completar recordatorio',
  
  // Habits-related
  habitsToday: 'Hábitos de Hoy',
  dailyHabits: 'Hábitos Diarios',
  noHabitsToday: 'No hay hábitos para hoy',
  errorUpdatingHabit: 'Error al actualizar hábito',
  
  // Weather-related
  weather: 'Clima',
  loadingWeather: 'Cargando clima...',
  weatherNotAvailable: 'Clima no disponible',
  humidity: 'Humedad',
  windSpeed: 'Velocidad del viento',
  
  // Stock Market-related
  stockMarket: 'Bolsa de Valores',
  loadingStocks: 'Cargando cotizaciones...',
  stocksNotAvailable: 'Cotizaciones no disponibles',
  
  // Module names and descriptions
  personalFinance: 'Finanzas Personales',
  financeDesc: 'Gestiona tu presupuesto, rastrea gastos, monitorea deudas y alcanza tus metas financieras.',
  taskManagement: 'Gestión de Tareas',
  taskDesc: 'Organiza tus tareas, establece prioridades y rastrea tu productividad.',
  timeManagement: 'Gestión del Tiempo',
  timeDesc: 'Planifica tu agenda, gestiona tu tiempo eficazmente y aumenta tu productividad.',
  habitTracker: 'Seguimiento de Hábitos',
  habitsDesc: 'Construye hábitos positivos y rastrea tu progreso diario.',
  personalJournal: 'Diario Personal',
  journalDesc: 'Mantén un diario privado para reflexionar sobre tus pensamientos y experiencias.',
  reminderManagement: 'Recordatorios',
  
  // Additional features
  tasks: 'Tareas',
  notes: 'Notas',
  lists: 'Listas',
  feedback: 'Comentarios',
  products: 'Productos',
  cart: 'Carrito',
  orders: 'Órdenes',
  subscription: 'Suscripción',
  
  // Why choose section
  whyChoose: '¿Por qué Elegir PlanWiseNow?',
  platformHelps: 'Nuestra plataforma te ayuda a tomar control de tu vida personal y profesional',
  freeToUse: 'Gratis para Usar',
  freeToUseDesc: 'Comienza a gestionar tu vida sin ningún costo. Accede a funcionalidades esenciales completamente gratis.',
  bilingualPlatform: 'Plataforma Bilingüe',
  bilingualPlatformDesc: 'Disponible en inglés y español para servir a una comunidad global.',
  allInOneSolution: 'Solución Todo-en-Uno',
  allInOneSolutionDesc: 'Todo lo que necesitas en un solo lugar: finanzas, tareas, hábitos, metas y más.',
  
  // Admin translations
  administration: 'Administración',
  adminProducts: 'Gestionar Productos',
  adminFeatures: 'Gestionar Funciones',
  adminSuggestedHabits: 'Hábitos Sugeridos',

  // Main features
  mainFeatures: 'Características principales',

  // Landing page translations
  welcomeTo: 'Bienvenido a',
  landingSubtitle: 'La plataforma todo-en-uno que necesitas para organizar tu vida, gestionar tu tiempo y alcanzar tus objetivos de manera eficiente.',
  personalProductivityAssistant: 'Tu asistente personal de productividad',
  signIn: 'Iniciar Sesión',
  createFreeAccount: 'Crear Cuenta Gratis',
  alreadyHaveAccount: 'Ya tengo cuenta',
  
  // Stats
  landingModules: 'Módulos',
  landingCategories: 'Categorías', 
  possibilities: 'Posibilidades',
  
  // Modules section
  allToolsYouNeed: 'Todas las herramientas que necesitas',
  completeEcosystem: 'Un ecosistema completo de productividad diseñado para adaptarse a tu estilo de vida',
  
  // Module titles and descriptions
  todayView: 'Vista Hoy',
  todayViewDesc: 'Dashboard personalizado con resumen diario',
   landingTaskManagement: 'Gestión de Tareas',
  taskManagementDesc: 'Organiza y prioriza tus tareas con la matriz de Eisenhower',
   landingTimeManagement: 'Gestión del Tiempo',
  timeManagementDesc: 'Técnica Pomodoro integrada para maximizar tu productividad',
   landingReminders: 'Recordatorios',
  remindersDesc: 'Nunca olvides tareas importantes con recordatorios inteligentes',
  quickNotes: 'Notas Rápidas',
  quickNotesDesc: 'Captura ideas e información importante al instante',
  listsChecklists: 'Listas y Checklists',
  listsChecklistsDesc: 'Crea listas organizadas para cualquier propósito',
  habitTracking: 'Seguimiento de Hábitos',
  habitTrackingDesc: 'Construye hábitos positivos y mantén el seguimiento',
  goalsObjectives: 'Metas y Objetivos',
  goalsObjectivesDesc: 'Define, planifica y alcanza tus objetivos a largo plazo',
  personalDiary: 'Diario Personal',
  personalDiaryDesc: 'Reflexiona y documenta tu crecimiento personal',
  financeControl: 'Control Financiero',
  financeControlDesc: 'Gestiona presupuestos, inversiones y patrimonio neto',
  ideasProjects: 'Ideas y Proyectos',
  ideasProjectsDesc: 'Captura y desarrolla ideas creativas en un kanban',
  blogArticles: 'Blog con Artículos',
  blogArticlesDesc: 'Comparte conocimiento y experiencias a través de artículos',
  youtubeChannel: 'Canal YouTube PlanWiseNow',
  youtubeChannelDesc: 'Contenido exclusivo y tutoriales sobre productividad',
  
  // Categories
  landingProductivity: 'Productividad',
  personalDevelopment: 'Desarrollo Personal',
  landingFinance: 'Finanzas',
  organization: 'Organización',
  creativity: 'Creatividad',
  
  // Features
  dailySummary: 'Resumen del día',
  pendingTasks: 'Tareas pendientes',
  landingHabits: 'Hábitos',
   landingWeather: 'Clima',
  eisenhowerMatrix: 'Matriz Eisenhower',
  subtasks: 'Subtareas',
  deadlines: 'Fechas límite',
  pomodoroTimer: 'Timer Pomodoro',
  statistics: 'Estadísticas',
  breaks: 'Descansos',
  sessions: 'Sesiones',
  flexibleDates: 'Fechas flexibles',
  repetition: 'Repetición',
  notifications: 'Notificaciones',
  priorities: 'Prioridades',
  richEditing: 'Edición rica',
  tags: 'Etiquetas',
  search: 'Búsqueda',
  dragDrop: 'Drag & drop',
  templates: 'Plantillas',
  progress: 'Progreso',
  dailyTracker: 'Tracker diario',
  streaks: 'Rachas',
  smartPlanning: 'Planificación SMART',
  milestones: 'Hitos',
  analysis: 'Análisis',
  privateEntries: 'Entradas privadas',
  moodAnalysis: 'Análisis de ánimo',
  themes: 'Temas',
  encryption: 'Cifrado',
  budgets: 'Presupuestos',
  investments: 'Inversiones',
  debts: 'Deudas',
  netWorth: 'Patrimonio neto',
  kanbanBoard: 'Kanban board',
  ideaEvolution: 'Evolución de ideas',
  resources: 'Recursos',
  states: 'Estados',
  videoTutorials: 'Videos tutoriales',
  weeklyTips: 'Tips semanales',
  useCases: 'Casos de uso',
  community: 'Comunidad',
  
  // Why choose section
  readyToTransform: '¿Listo para transformar tu productividad?',
  joinThousands: 'Únete a miles de usuarios que ya están alcanzando sus objetivos con PlanWiseNow.',
  startFreeNow: 'Comenzar Gratis Ahora',
  
  // Features highlight
  securePrivate: 'Seguro y Privado',
  securePrivateDesc: 'Tus datos están protegidos con cifrado de grado militar y políticas de privacidad estrictas.',
  continuousImprovement: 'Mejora Continua',
  continuousImprovementDesc: 'Análisis y estadísticas detalladas para ayudarte a mejorar constantemente tu productividad.',
  easyToUse: 'Fácil de Usar',
  easyToUseDesc: 'Interfaz intuitiva y diseño elegante que se adapta a tu flujo de trabajo natural.',
  
  // Footer
  landingPersonalAssistant: 'Tu asistente personal para una vida más organizada y productiva.',
  
  // Important Data module
  importantDataModule: 'Datos Importantes',
  importantDataDescription: 'Guarda y protege tus datos más sensibles con encriptación',
  
  // Documents module
  documents: 'Documentos',
  documentsDescription: 'Crea, edita y gestiona documentos de texto con formato enriquecido y exportación a PDF',
  wordProcessor: 'Procesador de Texto',
  pdfViewer: 'Visor de PDF',
  
  // Features highlights
  dailyEntries: 'Entradas diarias',
  moodTracking: 'Seguimiento de ánimo',
  textEditor: 'Editor de texto',
  advancedSearch: 'Búsqueda avanzada',
  scheduledReminders: 'Recordatorios programados',
  calendarIntegration: 'Integración calendario',
  shareFiles: 'Compartir archivos',
  documentsManagement: 'Gestión de Documentos',
  documentsManagementDesc: 'Organiza, visualiza y comparte documentos PDF con herramientas avanzadas',
  
  // Additional modules
  moreToolsIncluded: 'Más herramientas incluidas',
  
  // Premium features
  premiumFeatures: 'Funcionalidades Premium',
  aiAssistant: 'Asistente IA',
  aiAssistantDesc: 'Asistente inteligente para potenciar tu productividad',
  automation: 'Automatización',
  automationDesc: 'Automatiza tareas repetitivas y flujos de trabajo',
  advancedReports: 'Reportes Avanzados',
  advancedReportsDesc: 'Analytics detallados y métricas de productividad',
  teamCollaboration: 'Colaboración en Equipo',
  teamCollaborationDesc: 'Funciones avanzadas para trabajar en equipo',
  premium: 'Premium',
  
  // Counter
  of: 'de',
  
  // Sidebar modules
  productivityCenter: 'Centro de Productividad',
  integrations: 'Integraciones',
  store: 'Tienda',
  financialEducation: 'Educación Financiera',
  productivityEducation: 'Educación para la Productividad',
  others: 'Otros',
};
